import { cn } from "@utils/Cn";
import { Oval } from "react-loader-spinner";

const MerchantButton = ({
  children,
  merchant,
  onClick,
  width = "full",
  className,
  type = "button",
  disabled,
  loading = false,
}) => {
  return (
    <button
      onClick={onClick}
      disabled={disabled || loading}
      type={type}
      style={{
        backgroundColor: merchant.colourSet?.button || "#F95816",
        color: merchant.colourSet?.buttonText || "white",
      }}
      className={cn(
        "py-3 text-center rounded-xl disabled:opacity-[.3] font-medium cursor-pointer relative",
        `w-${width}`,
        className
      )}
    >
      {loading ? (
        <div className="flex items-center justify-center">
          <Oval
            height={24}
            width={24}
            color={merchant.colourSet?.buttonText || "white"}
            secondaryColor="transparent"
            strokeWidth={6}
            strokeWidthSecondary={6}
          />
        </div>
      ) : (
        children
      )}
    </button>
  );
};

const SecondaryButton = ({
  children,
  onClick,
  width = "full",
  className,
  disabled,
}) => {
  // Todo cusom colors
  return (
    <button
      onClick={onClick}
      disabled={disabled}
      className={cn(
        "py-3 text-center rounded-xl border border-zinc-300 font-medium cursor-pointer",
        `w-${width}`,
        className
      )}
    >
      {children}
    </button>
  );
};

export { MerchantButton, SecondaryButton };
